
import { ResultData } from "@nt-portal/common-sdk";
import { CountResult, TCMScheduleItem, TCMScheduleItemService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";



export interface TCMScheduleItemOptions extends ControllerOptions<TCMScheduleItem> {
    sheetId?: string;
}

export const createTCMScheduleItem = (inObj: Partial<TCMScheduleItem>) => {

    let item: TCMScheduleItem = {
        id: "",
        schedule: inObj.schedule ?? {
            id: "",
            name: "",
            createdBy: "",
            rankingCalculationPoints: 0,
            rankingCalculationPrice: 0
        },
        createdBy: ""
    }
    return item;
}

export class ClientTCMScheduleItemService extends BaseClientService implements DataController<TCMScheduleItem> {

    private _service: TCMScheduleItemService;


    constructor() {
        super();
        this._service = new TCMScheduleItemService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async get(options: TCMScheduleItemOptions): Promise<ResultData<TCMScheduleItem>> {
        if (!options.sheetId) {
            throw new Error("SheetId is required to get Schedule Items");
        }
        return await this._service.get(this.buildFetchParams(options), this.token, options.sheetId, options.filter);

    }

    public async count(options: TCMScheduleItemOptions): Promise<number> {


        let result = await this._service.count(this.token, options.sheetId, options.filter);
        return result.count;

    }

    public async getLookup(options: TCMScheduleItemOptions): Promise<ResultData<TCMScheduleItem>> {
        if (!options.sheetId) {
            throw new Error("SheetId is required to get Schedule Items");
        }
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token, options.sheetId, options.filter);
        return data;
    }

    public async getById(options: TCMScheduleItemOptions): Promise<TCMScheduleItem | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMScheduleItemOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMScheduleItemOptions): Promise<TCMScheduleItem | TCMScheduleItem[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMScheduleItemOptions): Promise<TCMScheduleItem | TCMScheduleItem[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    // public async validate(options: TCMScheduleItemOptions): Promise<ResultData<any[]>> {
    //     if (options.validation) {
    //         return await this._service.validate( this.token, options.validation,);
    //     }
    //     return {
    //         data:[],
    //         skip: -1,
    //         limit: -1,
    //         total: 0
    //     }
    // }

    // public async calcRanking(options: TCMScheduleItemOptions): Promise<any> {
    //     if (options.ranking) {
    //         return await this._service.ranking(this.token, options.ranking);
    //     } else {
    //         throw new Error("Options.ranking not provided");
    //     }
    // }


}